import { View } from 'backbone.marionette';
import pageNotFoundTmpl from './templates/page_not_found.hbs';

const PageNotFoundView = View.extend({
  template: pageNotFoundTmpl,
  pageName: 'Not Found'
});

export default PageNotFoundView;